import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiAdminSiteManager } from '../../enums/api-admin-site-manager.enum';
import { withSiteContext } from '../../interceptors/site-context.interceptor';
import { GenericConstants } from '../../enums/generic-constants.enum';
import { CreateSiteRequest } from '../../models/sites-management/create-site-request';
import { ValidateSiteRequest } from '../../models/sites-management/validate-site-request';


@Injectable({
  providedIn: 'root',
})
export class SitesService {
  constructor(private http: HttpClient) {}

  //get my sites
  getMySites() {
    let url = environment.baseUrl + ApiAdminSiteManager.GET_ALL_SITES;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);
    return this.http.get(url, { headers: headers });
  }

  //get my sites v2 with pagination
  getMySitesV2Paginated(size: number = 6, page: number = 0, query: string = '') {
    const url = environment.baseUrl + ApiAdminSiteManager.GET_ALL_SITES_V2;
    let params = new HttpParams().set('size', size).set('page', page);
    if (query.trim()) params = params.set('q', query.trim());
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);
    return this.http.get(url, { headers, params });
  }
  //getOnsite
  getMySite(siteId: string) {
    if (!siteId?.trim()) {
      return throwError(() => new Error('A site ID is required to load a shop.'));
    }
    let url = environment.baseUrl + ApiAdminSiteManager.GET_ONE_SITE + siteId;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);

    return this.http.get(url, { headers: headers, context: withSiteContext(siteId) });
  }

  //Validate site name
  validateSiteName(validateSite: ValidateSiteRequest) {
    let url = environment.baseUrl + ApiAdminSiteManager.VALIDATE_SHOP;

    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json');

    return this.http.post(url, JSON.stringify(validateSite), {
      headers: headers,
    });
  }
  //add new site (Shop)
  addNewSite(siteRequest: CreateSiteRequest) {
    let url = environment.baseUrl + ApiAdminSiteManager.ADD_NEW_SITE;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    //localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN )
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);

    return this.http.post(url, JSON.stringify(siteRequest), {
      headers: headers,
    });
  }
  
}
